// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sqb5","label":"styles_label__1iPfn"};